<template>
  <div>
    <div>
      <el-button type="primary" @click="search">搜索</el-button>
    </div>
    <div>
      <el-descriptions border :column="2">
        <el-descriptions-item label="房产名称">
          <el-autocomplete
            style="min-width: 400px;max-width: 100%"
            v-model="house_name"
            :fetch-suggestions="querySearchAsyncRoom"
            @select="handleSelect"
            placeholder="请输入房产"
            popper-class="autocomplete-room"
            clearable
          ></el-autocomplete>
        </el-descriptions-item>
        <el-descriptions-item label="操作类型">
          <el-select v-model="where.action_type" placeholder="请选择操作类型" @change="search">
            <el-option label="添加" value="add"></el-option>
            <el-option label="修改" value="update"></el-option>
            <el-option label="删除" value="del"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="操作时间">
          <el-date-picker
            v-model="where.start_time"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="开始日期"
            style="width: 200px;"
            @change="search"
          ></el-date-picker>
          <el-date-picker
            v-model="where.end_time"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="结束日期"
            style="width: 200px;"
            @change="search"
          ></el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="操作人">
          <el-input v-model="where.user_name" placeholder="请输入操作人" @change="search"></el-input>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <el-table :data="pageData.data" style="width: 100%" height="70vh" border>
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="house_name" label="房产名称" min-width="320"></el-table-column>
      <el-table-column prop="table_name" label="业务表名" width="140"></el-table-column>
      <el-table-column prop="create_time" label="操作时间" width="140"></el-table-column>
      <el-table-column prop="action_type" label="操作类型" width="120"></el-table-column>
      <el-table-column prop="user_name" label="操作人" width="180"></el-table-column>
    </el-table>
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pageData.currentPage"
        :page-size="pageData.pageSize"
        :total="pageData.total"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Http from "../../common/Http";
export default {
  name: "HouseLog",
  inject: ['mainObj'],
  data() {
    return {
      where:{
        user_name:'',
        action_type:'',
        start_time:'',
        end_time:'',
      },
      pageData: {
        data: [],
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      house_name: this.mainObj.house_name,
    }
  },
  mounted() {
    this.house_name = this.mainObj.house_name;
    this.getList();
  },
  methods: {
    changePage(page) {
      this.pageData.currentPage = page;
      this.getList();
    },
    getList(){
      const that=this;
      Http.post("HouseLog/getList",{
        project_id:that.mainObj.project_id,
        house_name:that.mainObj.house_name,
        ...that.where,
        page:that.pageData.currentPage,
        limit:that.pageData.pageSize
      },ret=>{
        if(ret.code) {
          that.pageData = ret.data;
        }
      })
    },
    search() {
      this.changePage(1);
    },
    querySearchAsyncRoom(queryString, cb){
      if(!queryString){
        cb([]);
      }else {
        ERP.postRequest({
          url:"admin/Customer/getHouseList",
          data:{keyWord:queryString}
        },ret=>{
          if(ret.code) {
            cb(ret.data)
          }
        })
      }
    },
    handleSelect(item) {
      this.house_name=item.value||'';
      this.mainObj.house_id=item.id||0;
      this.mainObj.house_name=item.value||'';
      this.search();
    },
  },
  watch: {
    "mainObj.house_name": function (newVal, oldVal) {
      this.house_name = newVal;
      this.getList();
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/components/house/HouseLog.vue